import React from 'react'
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";

import { login, logout } from '../GlobalStateContainer/actions';

class AccountNavigation extends React.Component {
    constructor(props) {
        super(props);
    }

    callLogin = () => { login(this.props.dispatch, this.props.location); }
    callLogout = () => { this.props.dispatch(logout); }

    render() {
        const currentUser = this.props.user;
        return (
            <ul className="nav nav-pills pull-right">
                {!!currentUser &&
                    <li>
                        <a href="/prod-mgmt/myaccount">
                            <span className="glyphicon glyphicon-user"></span>
                            <span id="labelAccountOption">
                                {currentUser.profile.name}
                            </span>
                        </a>
                    </li>
                }
                <li>
                    {!!currentUser
                        ? <button className="btn btn-link" onClick={this.callLogout}><span className="glyphicon glyphicon-lock"></span> Logout</button>
                        : <button className="btn btn-link" onClick={this.callLogin}><span className="glyphicon glyphicon-lock"></span> Login</button>
                    }
                </li>
            </ul>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    menuItems: ownProps.menuItems,
    alertMessage: ownProps.alertMessage,
    user: state.oidc.user,
    location: ownProps.location
 });

export default withRouter(connect(mapStateToProps)(AccountNavigation))